import { isV2Enabled } from "@/lib/helper/env/isV2Enabled";

interface ComponentVersionSwitchProps {
  envKey: string;
  OldComponent: React.FC;
  NewComponent: React.FC;
}

export const ComponentVersionSwitch = ({
  envKey,
  OldComponent,
  NewComponent,
}: ComponentVersionSwitchProps): JSX.Element =>
  isV2Enabled(envKey) ? <NewComponent /> : <OldComponent />;
